import { HelpfulHints } from '../common/HelpfulHints'
import s from '../HelpCenterModal.scss'

const PipelineSetup = () => {
  return (
    <div className={s.container}>
      <div className={s.leftContainer}>
        <iframe
          width="500"
          height="315"
          src="https://www.youtube.com/embed/EpEoCpP3pgY"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        />
        <h3 className={s.title}>Set Up Your Sales Pipeline in iDeal CRM</h3>
        <div className={s.content}>
          Setting up a sales pipeline with the right stages is an important step in adopting a
          management tool. You want to make sure that your pipeline includes all stages needed for
          everyone involved in the sales process. In order to do that, you want to:
          <ol className={s.styledList}>
            <li>Document Your Sales Process</li>
            <li>Identify Pipeline Stages from Your Sales Process</li>
            <li>Create Pipeline Stages in iDeal CRM that Match Your Process</li>
          </ol>
          Watch the video above or download{' '}
          <a
            href="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/Set+Up+Your+Sales+Pipeline+in+iDeal+CRM.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            Set Up Your Sales Pipeline with iDeal CRM
          </a>{' '}
          for step-by-step instructions.
        </div>
      </div>
      <div className={s.rightContainer}>
        <HelpfulHints
          downloadLink="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/Set+Up+Your+Sales+Pipeline+in+iDeal+CRM.pdf"
          thumbnailUrl="https://ideal-help.s3.us-east-2.amazonaws.com/thumbnails/Set+Up+Your+Sales+Pipeline+with+iDeal+CRM.jpg"
          text="Set Up Your Sales Pipeline with iDeal CRM"
        />
      </div>
    </div>
  )
}

export default PipelineSetup
